module.exports = __webpack_public_path__ + "img/nav-02.d1611bed.svg";